module.exports = __webpack_public_path__ + "media/images/proof_links/colored/disneyplus-44328c2f3dd0ff3c5216ca94808ffce7.svg";